var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBycuisine1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.054,
    height: 55.964,
    viewBox: "0 0 56.054 55.964",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Firefly_Create_a_clean_minimal_vector_icon_of_a_restaurant_cloche-dome_serving_dish_with_a_handle_o",
    "data-name": "Firefly Create a clean, minimal vector icon of a restaurant cloche-dome serving dish with a handle o",
    transform: "translate(-161.772 -161.418)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19023",
    "data-name": "Path 19023",
    d: "M187.96,161.464c-21.673,1.208-33.608,26.322-21.12,44.124,11.731,16.722,37.436,15.431,47.37-2.4C225.061,183.7,210.09,160.23,187.96,161.464Z",
    transform: "translate(0 0)",
    fill: "#f9f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19024",
    "data-name": "Path 19024",
    d: "M187.96,161.464c22.13-1.234,37.1,22.237,26.25,41.719-9.934,17.836-35.639,19.127-47.37,2.4C154.352,187.787,166.287,162.673,187.96,161.464Zm-1.6,12.1a1.506,1.506,0,0,0-.16,2.885c.562.172,1.889-.042,2.164.08.31.137,0,1.449-.2,1.563-.182.105-2.569.321-3.086.441A19.866,19.866,0,0,0,171.168,190.6c-.457,1.233-1.887,5.092.12,5.49h37.03c1.374-.673,1.1-1.757.842-3.006-1.419-6.79-7.622-12.868-14.307-14.467-.508-.122-3.356-.481-3.487-.6-.152-.14-.505-1.348-.2-1.483.36-.159,1.708.149,2.4-.16a1.551,1.551,0,0,0,.08-2.645A55.411,55.411,0,0,0,186.357,173.567ZM169.2,197.052a1.559,1.559,0,0,0,.08,3.046h40.958a1.56,1.56,0,0,0,.16-3.046Z",
    transform: "translate(0 0)",
    fill: "#022161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19026",
    "data-name": "Path 19026",
    d: "M549.985,397a17.069,17.069,0,0,1,12.3,8.456,21.368,21.368,0,0,1,1.683,3.767.883.883,0,0,1-1.162.922c-.641-.14-1.019-2.049-1.323-2.685a18.7,18.7,0,0,0-9.5-9.338c-.306-.138-2.015-.635-2.084-.721A.284.284,0,0,1,549.985,397Z",
    transform: "translate(-356.975 -216.7)",
    fill: "#022161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19027",
    "data-name": "Path 19027",
    d: "M335.924,423.987a.82.82,0,0,1,.6,1.323c-.132.171-1.968.855-2.365,1.082a15.859,15.859,0,0,0-6.452,6.853c-.423.8-.359,1.973-1.723,1.723-2.417-.442,1.147-5.125,1.884-5.971C329.224,427.439,333.877,423.913,335.924,423.987Z",
    transform: "translate(-150.288 -241.523)",
    fill: "#022161"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBycuisine1);
export default __webpack_public_path__ + "static/media/by cuisine (1).80024e7e393a597fcbe952a5b8cfe654.svg";
export { ForwardRef as ReactComponent };